import React from "react";
import { QRCodeSVG } from "qrcode.react";


const QrCode = ({ showDetails }) => {

    // const [apSSID, setApSSID] = useState("");
    // const [apPassword, setApPassword] = useState("");

    // const baseURL = "{BaseURL}?type=WiFi&ssid={STA_SSID}&pass={STA_PASSWORD}";
    // const apiEndpoint = "http://172.24.1.1:8080/edge/diagnostic";

    // const fetchCredentials = async () => {
    //     try {
    //         const response = await fetch(apiEndpoint);
    //         if (!response.ok) {
    //             throw new Error(`HTTP error! status: ${response.status}`);
    //         }
    //         const data = await response.json();

    //         setApSSID(data.ssid);
    //         setApPassword(data.password);
    //     } catch (error) {
    //         console.error("Error fetching credentials:", error);
    //     }
    // };

    // useEffect(() => {
    //     fetchCredentials();
    // }, []);

    const apSSID = "SmartAI-G-WiFi";
    const apPassword = "2fx4rstdt43d";

    const baseURL = "type=WiFi&ssid={STA_SSID}&pass={STA_PASSWORD}";

    const generateQRCodeURL = () => {
        if (!apSSID || !apPassword) return "";
        return baseURL
            .replace("{STA_SSID}", encodeURIComponent(apSSID))
            .replace("{STA_PASSWORD}", encodeURIComponent(apPassword));
    };

    return (
        <div className="qr-code">
            <QRCodeSVG
                value={generateQRCodeURL()}
                size={120}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"}
                imageSettings={{
                    src: "img/smartsolar.png",
                    height: 20,
                    width: 22,
                    opacity: 1,
                    excavate: true,

                }}
            />
            {showDetails && <div className="wifi-info">
                <span>ssid: {apSSID}</span><br />
                <span>password: {apPassword}</span>
            </div>}
        </div>



    );
};

export default QrCode;